module.exports = __webpack_public_path__ + "images/category_lp/alcohol/store_images/5_18b9fa6b3ae033bdd9ce45f2a8138eb9.png";